import axios from 'axios';
import {
  GET_PROGRAMS, ADD_PROGRAM, DELETE_PROGRAM, UPDATE_PROGRAM, PROGRAMS_LOADING
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

export const getPrograms = () => (dispatch, getState) => {
  dispatch({ type: PROGRAMS_LOADING });
  axios
    .get('/api/programs', tokenConfig(getState))
    .then(res => dispatch({ type: GET_PROGRAMS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addProgram = program => (dispatch, getState) => {
  axios
    .post('/api/programs', program, tokenConfig(getState))
    .then(res => dispatch({ type: ADD_PROGRAM, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const updateProgram = (id, program) => (dispatch, getState) => {
  axios
    .put(`/api/programs/${id}`, program, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_PROGRAM, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const deleteProgram = id => (dispatch, getState) => {
  axios
    .delete(`/api/programs/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_PROGRAM, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};
